import { Navigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { authClient, sessionCheckUnanswered } from "@/lib/auth-client";
import { SessionUnreachable } from "@/components/SessionUnreachable";
import { client } from "@/lib/api";
import { qk } from "@/lib/query-keys";

export function RootIndexRedirect() {
  const { data: session, isPending: sessionPending, error: sessionError, refetch: refetchSession } = authClient.useSession();

  const meQuery = useQuery({
    queryKey: qk.me(),
    queryFn: () => client.me(),
    enabled: !!session?.user,
    staleTime: 30_000,
  });

  if (sessionPending || (session?.user && meQuery.isPending)) {
    return (
      <div className="auth-shell">
        <div className="spinner" />
      </div>
    );
  }

  if (!session?.user && sessionCheckUnanswered(sessionError)) return <SessionUnreachable onRetry={() => { void refetchSession(); }} />;
  if (!session?.user) return <Navigate to="/login" />;

  if (meQuery.isError) {
    return (
      <div className="auth-shell">
        <div className="auth-card">
          <div className="panel">
            <p className="error-text" style={{ marginTop: 0 }}>
              Could not load your account. Please try again.
            </p>
            <button className="btn btn-primary btn-block" onClick={() => meQuery.refetch()}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  const firstOrg = meQuery.data?.orgs[0];
  if (firstOrg) return <Navigate to={`/o/${firstOrg.id}`} />;
  return <Navigate to="/onboarding" />;
}
